import useSearchSelect from 'features/legacy/hooks/search/useSearchSelect';

const useCountriesSearchSelect = sectors => useSearchSelect(sectors);

export default useCountriesSearchSelect;
